import { stringToDate } from '@dxb-web-ui-framework/common/utils/Date';
import { formatAmount } from '@dxb-web-ui-framework/common/utils/Math';

export const dateRangeFormatter = (dateFrom: string, dateTo: string, dateFormat: string) =>
  `${stringToDate({ date: dateFrom, formatExp: dateFormat })} - ${stringToDate({
    date: dateTo,
    formatExp: dateFormat,
  })}`;

export const amountFormatter = (amount: number, currency?: string) =>
  currency ? formatAmount(amount, currency) : amount;
